import { isPaymentVerificationOfPayeeCompatible } from 'src/core/modules/verification-of-payee/isPaymentVerificationOfPayeeCompatible';

import { type PaymentToSchedule } from '../models';
import { PaymentMethod } from '../models/paymentMethod';

export const isSchedulePaymentVerificationOfPayeeCompatible = (
  payment: PaymentToSchedule,
  companyCurrency: string,
): boolean => {
  return isPaymentVerificationOfPayeeCompatible({
    companyCurrency,
    targetCurrency: payment.amount.currency,
    targetCountry: payment.bill.counterparty.bankAddress?.country,
    iban: payment.bill.counterparty.bankAddress?.iban,
    isWireTransferAvailable:
      payment.paymentMethods[PaymentMethod.WireTransfer]?.active === true,
  });
};
